import React, { useState } from 'react';
import PropTypes from 'prop-types';

const CheckboxQuestion = ({ question, value, onChange, error }) => {
  const [otherText, setOtherText] = useState('');
  const options = question.options || [];
  const hasOtherOption = question.has_other_option;
  const otherOptionLabel = question.other_option_label || 'Other';
  
  // Parse current values (comma-separated string or array)
  const currentValues = Array.isArray(value) ? value : (value ? value.split(',') : []);
  const isOtherSelected = hasOtherOption && currentValues.some(v => v.includes(otherOptionLabel));

  const handleCheckboxChange = (option, checked) => {
    let newValues = [...currentValues];
    
    if (option === otherOptionLabel && hasOtherOption) {
      if (checked) {
        newValues.push(otherText || otherOptionLabel);
      } else {
        newValues = newValues.filter(v => !v.includes(otherOptionLabel));
        setOtherText('');
      }
    } else {
      if (checked) {
        newValues.push(option);
      } else {
        newValues = newValues.filter(v => v !== option);
      }
    }
    
    onChange(newValues.join(','));
  };

  const handleOtherTextChange = (text) => {
    setOtherText(text);
    if (isOtherSelected) {
      const newValues = currentValues.filter(v => !v.includes(otherOptionLabel));
      if (text) {
        newValues.push(text);
      } else {
        newValues.push(otherOptionLabel);
      }
      onChange(newValues.join(','));
    }
  };

  const isChecked = (option) => {
    if (option === otherOptionLabel && hasOtherOption) {
      return isOtherSelected;
    }
    return currentValues.includes(option);
  };

  return (
    <div className="checkbox-group">
      {options.map((option, index) => {
        const optionId = `${question.id}_${index}`;
        return (
          <div key={index} className="checkbox-option">
            <input
              type="checkbox"
              id={optionId}
              checked={isChecked(option)}
              onChange={(e) => handleCheckboxChange(option, e.target.checked)}
            />
            <label htmlFor={optionId}>
              {option}
            </label>
          </div>
        );
      })}
      
      {hasOtherOption && (
        <div className="checkbox-option">
          <input
            type="checkbox"
            id={`${question.id}_other`}
            checked={isOtherSelected}
            onChange={(e) => handleCheckboxChange(otherOptionLabel, e.target.checked)}
          />
          <label htmlFor={`${question.id}_other`}>
            {otherOptionLabel}
          </label>
          
          {isOtherSelected && (
            <div className="other-text-input" style={{ marginTop: '8px', marginLeft: '24px' }}>
              <input
                type="text"
                value={otherText}
                onChange={(e) => handleOtherTextChange(e.target.value)}
                placeholder="Please specify..."
                className="form-control form-control-sm"
                style={{ maxWidth: '300px' }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

CheckboxQuestion.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    options: PropTypes.array,
    has_other_option: PropTypes.bool,
    other_option_label: PropTypes.string
  }).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string
};

export default CheckboxQuestion;